/**
 * These codes represent the ability for a customer to purchase a fuel.
 *
 * @see https://origindd.atlassian.net/wiki/display/DIG/Copy%3A+Error+messages
 */

/**
 * The fuel is fully eligible for purchase
 */
export const FULL = '01';
/**
 * The fuel is only partially eligible for purchase
 */
export const PARTIAL = '02';
/**
 * The fuel is not available for purchase
 */
export const NONE = '03';
/**
 * The fuel might be available for purchase, but we're not sure
 */
export const UNKNOWN = '04';

/**
 * The connection might take a while because of the customer's distributor and/or location
 */
export const LONG_CONNECTION_TIME = '05';
/**
 * unmetered gas not available for purchase
 */
export const UNMETERED = '07';
/**
 * unmetered gas not available for purchase
 */
export const GASCOOKTOP = '08';
/**
 * Embedded network, not available for purchase
 */
export const EMBEDDEDNETWORK = '09';
